import React from 'react';
import { defineMessages, t } from '@sm/intl';

import BrandedEmbeddedHeader from '~app/components/BrandedEmbeddedHeader';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.Embedded.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The primary message on the webpage. Used to say thank you to survey respondents and signal the end of the survey.',
  },
});

export type Props = {
  message?: string;
};

const Embedded = ({ message = t(COPY.THANK_YOU) }: Props): React.ReactElement => (
  <BrandedEmbeddedHeader message={message} utSource="survey-thanks" />
);

export default Embedded;
